import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { DenyListTypes, DenyListInterface } from './types';

// List Denylists
export const listDenylistRequest = (payload: object) =>
  action(DenyListTypes.LIST_DENYLIST_REQUEST, payload);
export const listDenylistSuccess = (payload: {
  denylistList: DenyListInterface[];
}) => action(DenyListTypes.LIST_DENYLIST_SUCCESS, payload);
export const listDenylistFailure = () =>
  action(DenyListTypes.LIST_DENYLIST_FAILURE);

// Get Denylist
export const getDenylistRequest = (payload: object) =>
  action(DenyListTypes.GET_DENYLIST_REQUEST, payload);
export const getDenylistSuccess = (payload: {
  denylistData: DenyListInterface;
}) => action(DenyListTypes.GET_DENYLIST_SUCCESS, payload);
export const getDenylistFailure = () =>
  action(DenyListTypes.GET_DENYLIST_FAILURE);

// Create Denylist
export const createDenylistRequest = (payload: object) =>
  action(DenyListTypes.CREATE_DENYLIST_REQUEST, payload);
export const createDenylistSuccess = (payload: {
  denylistData: DenyListInterface;
}) => action(DenyListTypes.CREATE_DENYLIST_SUCCESS, payload);
export const createDenylistFailure = () =>
  action(DenyListTypes.CREATE_DENYLIST_FAILURE);
